window.onload = () => {
    document.querySelector('#selectall').addEventListener('click', function(event) {
        document.querySelectorAll('.item_checkbox').forEach(box => {
            box.checked = this.checked
        })
    })
    document.querySelector('#action-form-button').addEventListener('click', function(event) {
        document.querySelector('#separesultform').submit()
    })
}
